/**
 * @author Base Digital
 *
 * Force `select` width to the width of the
 * selected option.
 *
 * @default arrowWidth (int) | if `select` not
 * 		set to `border-box`
 *
 * 1. Whenever the select changes...
 * 2. Create a dummy `span` element using the
 *    same text as the selected (current) option.
 * 3. Append it to the body to get its width,
 *    then remove it.
 * 4. Resize the original select.
 * 5. Force a first `change` event so that the
 *    select is resized on init.
 */
(function( $ ) {

	$.fn.resizeSelect = function( options ) {

		var defaults = {
			arrowWidth: 3
		};

		var params = $.extend( defaults, options );

		return this.each(function() {

			function resize( $theSelect ) {
				/* [2] */
				var text = $theSelect.find('option:selected').text();
				var $dummyOption = $('<span class="u-text-size-small">').html(text);

				/* [3] */
				$dummyOption.appendTo('body');
				var width = $dummyOption.innerWidth();
				// console.log('width', width);
				$dummyOption.remove();

				/* [4] */
				$theSelect.width(width + params.arrowWidth);
			}

			resize( $(this) );

			$(this).change(function(){ /* [1] */
				var $theSelect = $(this);

				resize( $(this) );

			// }).change(); /* [5] */
			});

		});
	};

})(jQuery, window);
